<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js' 
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			tableData: {
				type:Array,
				default:[]
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {
			this.$nextTick(()=>{

			})
		},
		methods: {
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			forpz() {
				if (this.showpz) {
					this.$emit("forpz", "")
				}
			},
			
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {},
			
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
